<template>
  <div class="app-wrapper">
    <sidebar />
    <div class="main-container">
      <app-header />
      <app-main />
    </div>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar/index.vue'
import AppHeader from './components/Header/index.vue'
import AppMain from './components/AppMain/index.vue'

export default {
  name: 'AppLayout',
  components: { Sidebar, AppHeader, AppMain }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
}

.main-container {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
